import React, { useEffect, useState, useRef } from "react";
import { Helmet } from 'react-helmet-async';
import { useParams } from "react-router-dom";
import { motion, useInView } from "framer-motion";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import axios from "axios";
import { secretKey, baseURL } from "../utils/constant";
import { Container, Row, Col, Nav, Form, Button } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinus, faPlus } from '@fortawesome/free-solid-svg-icons';
import { faFacebook, faInstagram } from '@fortawesome/free-brands-svg-icons'
import Video1 from "../assets/videos/product1.MP4";
import Video2 from "../assets/videos/product2.MP4";
import Video3 from "../assets/videos/product3.MP4";
import StripeImage from "../assets/stripe/image-1.png";
import { useCart } from "../components/Cart";

function Product({ setPageTitle }) {
    const { id } = useParams();
    const [product, setProduct] = useState(null);
    const [price, setPrice] = useState(null);
    const [quantity, setQuantity] = useState(1); // Quantity state
    const imageRef = useRef(null);
    const { addToCart } = useCart();

    const handleAddToCart = () => {
        if (product) {
            addToCart({
                ...product,
                unit_amount: price.unit_amount, // Include unit_amount
                currency: price.currency, // Include currency
            },
                quantity);
        }
    };

    const headers = {
        Authorization: `Bearer ${secretKey}`,
        "Content-Type": "application/x-www-form-urlencoded",
    };

    // Fetch product details
    useEffect(() => {
        axios
            .get(`${baseURL}/v1/products/${id}`, {
                headers,
            })
            .then((response) => {
                const fetchedProduct = response.data;
                // console.log("Fetched Product:", fetchedProduct);
                setProduct(fetchedProduct);
            })
            .catch((err) => {
                console.error("Error in API Call", err);
            });
    }, [id]);

    // Fetch price details once `product.default_price` is available
    useEffect(() => {
        if (product?.default_price) {
            axios
                .get(`https://api.stripe.com/v1/prices/${product.default_price}`, {
                    headers,
                })
                .then((response) => {
                    const { unit_amount, currency } = response.data;
                    setPrice({ unit_amount, currency });
                })
                .catch((err) => {
                    console.error(`Error fetching price for ${product.default_price}`, err);
                });
        }
    }, [product]);

    // Set page title
    useEffect(() => {
        if (product?.name) {
            setPageTitle(`${product.name} - Bait Al Anaqah`);
        }
    }, [product, setPageTitle]);

    // Handle increment and decrement
    const handleIncrement = () => setQuantity((prev) => prev + 1);
    const handleDecrement = () => setQuantity((prev) => (prev > 1 ? prev - 1 : 1));

    return (
        <>
        <Helmet>
        <meta name="keywords" content="Bait Al Anaqah, Bespoke, Uniforms, Alteration, Custom, Dubai" />
        <meta name="title" property="og:title" content={setPageTitle}></meta>
        <meta property="og:type" content="website" />
        <meta name="description" property="og:description" content="Experience the elegance of Bait Al Anaqah, where every creation tells a story and reflects your unique identity while honoring your values." />
        <meta name="image" property="og:image" content={product?.images ? product.images[0] : undefined} />
      </Helmet>
            <Navbar />
            <Container fluid className="g-0">
                <Row className="g-0">
                    <Col lg={6} className="vhx-80 overflow-hidden">
                        {product ? (
                            <div>
                                {id === "prod_RKTMY9RIr9a5ba" && (
                                    <video
                                        className="w-100"
                                        controls={false}
                                        autoPlay
                                        loop
                                        muted
                                    >
                                        <source src={Video3} type="video/mp4" />
                                        Your browser does not support the video tag.
                                    </video>
                                )}
                                {id === "prod_RM7CxhA2cY96xK" && (
                                    <video
                                        className="w-100"
                                        controls={false}
                                        autoPlay
                                        loop
                                        muted
                                    >
                                        <source src={Video2} type="video/mp4" />
                                        Your browser does not support the video tag.
                                    </video>
                                )}
                                {id === "prod_RM7lc6fmaFOz2Y" && (
                                    <video
                                        className="w-100"
                                        controls={false}
                                        autoPlay
                                        loop
                                        muted
                                    >
                                        <source src={Video1} type="video/mp4" />
                                        Your browser does not support the video tag.
                                    </video>
                                )}
                            </div>
                        ) : (
                            <></>
                        )}
                    </Col>
                    <Col lg={4} className="mx-auto py-5 g-5 border-bottom">
                        {product ? (
                            <div>
                                <h5 className="fw-bold mb-3">{product.name}</h5>
                                {price ? (
                                    <p className="text-uppercase">
                                        {`${price.unit_amount / 100} ${price.currency.toUpperCase()}`}
                                    </p>
                                ) : (
                                    <p>Loading price...</p>
                                )}
                                <p>Description</p>
                                <p className="text-small mb-5">{product.description}</p>
                                <Col
                                    lg={4}
                                    className="text-center p-2 border d-inline-flex justify-content-center align-items-center mb-3"
                                >
                                    <span
                                        className="me-3 cursor-pointer"
                                        onClick={handleDecrement}
                                    >
                                        <FontAwesomeIcon icon={faMinus} />
                                    </span>
                                    <span className=" fs-5">{quantity}</span>
                                    <span
                                        className="ms-3 cursor-pointer"
                                        onClick={handleIncrement}
                                    >
                                        <FontAwesomeIcon icon={faPlus} />
                                    </span>
                                </Col>
                                <div className="d-grid gap-2 mb-3">
                                    <button
                                        className="btn btn-dark btn-lg text-decoration-none text-small rounded-3 mb-3"
                                        onClick={handleAddToCart}
                                    >
                                        Add to bag
                                    </button>
                                </div>
                                {/* <img src={StripeImage} className="img-fluid px-5" /> */}
                            </div>
                        ) : (
                            <p>Loading product...</p>
                        )}
                    </Col>
                </Row>
            </Container>
            <Footer />
        </>
    );
}

export default Product;
